function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $69d8d8c9fdfcb80a$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"f9bx4":"shopping-list.1a5e5e91.js","8OQ7p":"icons.788c0c72.svg","9sSkM":"index.69f00d55.js","g8iDC":"index.889a0bd7.js"}'));

parcelRequire("3ezVE");
parcelRequire("8IXMh");
parcelRequire("X4ZWf");
parcelRequire("3Xhi6");
parcelRequire("7Th1V");
parcelRequire("HlhYT");

var $e27edc6dc33d0133$exports = {};

$e27edc6dc33d0133$exports = new URL((parcelRequire("kyEFX")).resolve("8OQ7p"), import.meta.url).toString();


function $00ad9c3b4f97e097$export$2e2bcd8739ae039(arr) {
    return arr.map(({ _id: _id, book_image: book_image, title: title, list_name: list_name, description: description, author: author, buy_links: buy_links })=>{
        let bookCover = `<svg class="book-logo">
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports)))}#book"></use>
      </svg>`;
        if (book_image) bookCover = `<img class="shopping-list-img"
                    src="${book_image}" alt="${title}" 
                    loading="lazy"/>`;
        const amazonLinks = buy_links.find((obj)=>obj.name === "Amazon").url;
        const applebookLinks = buy_links.find((obj)=>obj.name === "Apple Books").url;
        const bookshopLinks = buy_links.find((obj)=>obj.name === "Bookshop").url;
        return `<li class="shopping-list-item">
            <div class="sh-wrapper">
                ${bookCover}
            </div>
            <div class="shopping-list-info">
              <div class="sh-markap-wrapper">
                <button type="button" id ="${_id}"class="trash-btn">
                    <svg class="trash-logo">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#trash"></use>
                    </svg>
                  </button>
                <h2 class="shopping-book-title">${title}</h2>
                <p class="shopping-book-polygraphy">${list_name}</p>
                <div class="sh-desc-wrapper">
                  <p class="shopping-book-desc">
                  ${description}
                  </p>
                </div>
              </div>
                
              <div class="sh-buy-wrapper" >
                <p class="shopping-book-author">${author}</p>
                  <ul class="links-to-buy">
                    <li class="item-to-buy">
                      <a href="${amazonLinks}" target="_blank" rel="noreferrer noopener nofollow">
                        <svg class="shop-logo-amazon">
                          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#amazon"></use>
                        </svg>
                      </a>
                    </li>
                    <li class="item-to-buy">
                      <a href="${applebookLinks}" target="_blank" rel="noreferrer noopener nofollow">
                        <svg class="shop-logo-applebook">
                          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#applebook"></use>
                        </svg>
                      </a>
                    </li>
                    <li class="item-to-buy">
                      <a href="${bookshopLinks}" target="_blank" rel="noreferrer noopener nofollow">
                        <svg class="shop-logo-bookshop">
                          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#bookshop"></use>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
            </div>
          </li>`;
    }).join("");
}



var $4rbgP = parcelRequire("4rbgP");
const $1a233a3e857cc48e$var$shRefs = {
    list: document.querySelector(".shopping-list-list"),
    emptyPage: document.querySelector(".empty-sh-page"),
    SHOPPING_LIST_LS: "shopping list"
};
$1a233a3e857cc48e$var$shRefs.list.addEventListener("click", $1a233a3e857cc48e$var$onDelete);
function $1a233a3e857cc48e$export$2e2bcd8739ae039(arr = []) {
    $1a233a3e857cc48e$var$shRefs.list.innerHTML = "";
    if (!arr.length) $1a233a3e857cc48e$var$emptyPage();
    else {
        const decipherArr = $1a233a3e857cc48e$var$arrDecipher(arr);
        $1a233a3e857cc48e$var$shRefs.emptyPage.classList.add("visually-hidden");
        $1a233a3e857cc48e$var$shRefs.list.insertAdjacentHTML("beforeend", (0, $00ad9c3b4f97e097$export$2e2bcd8739ae039)(decipherArr));
    }
}
function $1a233a3e857cc48e$var$arrDecipher(arr) {
    return arr.map((obj)=>({
            _id: obj.book.id,
            book_image: obj.book.img,
            title: obj.book.title,
            list_name: obj.book.bookName,
            description: obj.book.description,
            author: obj.book.author,
            buy_links: obj.book.shops
        }));
}
function $1a233a3e857cc48e$var$onDelete(eve) {
    const btn = eve.target.closest(".trash-btn");
    if (!btn) return;
    try {
        const bookArr = (0, $4rbgP.default).getData($1a233a3e857cc48e$var$shRefs.SHOPPING_LIST_LS);
        localStorage.removeItem($1a233a3e857cc48e$var$shRefs.SHOPPING_LIST_LS);
        const newBookArr = bookArr.filter((book)=>book.id !== btn.id); //replaced _id with id for encryption
        (0, $4rbgP.default).saveData($1a233a3e857cc48e$var$shRefs.SHOPPING_LIST_LS, newBookArr);
        if (!newBookArr.length) {
            (0, $caa314fd11aa2268$export$2e2bcd8739ae039)(newBookArr, 1, false, true);
            return;
        }
        (0, $caa314fd11aa2268$export$2e2bcd8739ae039)(newBookArr, 1, false, true);
    } catch (error) {
        console.log("ERROR!", error);
    }
}
function $1a233a3e857cc48e$var$emptyPage() {
    if ($1a233a3e857cc48e$var$shRefs.emptyPage.classList.contains("visually-hidden")) $1a233a3e857cc48e$var$shRefs.emptyPage.classList.remove("visually-hidden");
}



function $d69f682701e9dea8$export$2e2bcd8739ae039(murkupPages) {
    return `<div class="left-arrows-wrapper">
        <button class="js-pagination-button start" type="button" data-pagination="start">
          <svg class="pagination-icon-start" width="24" height="24">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#icon-arrow-ff"></use>
          </svg>
        </button>
        <button class="js-pagination-button backward" type="button" data-pagination="backward">
          <svg class="pagination-icon-backward" width="24" height="24">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#icon-arrow"></use>
          </svg>
        </button>
      </div>

      <ul class="js-pagination">
        ${murkupPages}
      </ul>

      <div class="right-arrows-wrapper">
        <button class="js-pagination-button forward" type="button" data-pagination="forward">
          <svg class="pagination-icon-forward" width="24" height="24">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#icon-arrow"></use>
          </svg>
        </button>
        <button class="js-pagination-button end" type="button" data-pagination="end">
          <svg class="pagination-icon-end" width="24" height="24">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($e27edc6dc33d0133$exports))}#icon-arrow-ff"></use>
          </svg>
        </button>
      </div>`;
}


let $caa314fd11aa2268$var$DATA = [];
let $caa314fd11aa2268$var$CARD_PER_PAGE = 0;
let $caa314fd11aa2268$var$TOTAL_PAGES = 0;
const $caa314fd11aa2268$var$screenInputControllers = {
    a: true,
    b: true
};
const $caa314fd11aa2268$var$refs = {
    paginationContainer: document.querySelector(".pagination-container")
};
$caa314fd11aa2268$var$refs.paginationContainer.addEventListener("click", $caa314fd11aa2268$var$onClickPagination);
let $caa314fd11aa2268$var$maxVisiblePages = 0;
function $caa314fd11aa2268$var$numbersOfPages(data) {
    $caa314fd11aa2268$var$TOTAL_PAGES = Math.ceil(data.length / $caa314fd11aa2268$var$CARD_PER_PAGE);
}
function $caa314fd11aa2268$export$2e2bcd8739ae039(data, initialPage = 1, isFirstRender = false, isDeleted = false) {
    if (data === "undefined" || data.length === 0) {
        $caa314fd11aa2268$var$DATA = [];
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)();
        return;
    }
    if (isFirstRender) {
        $caa314fd11aa2268$var$DATA = [
            ...data
        ];
        $caa314fd11aa2268$var$onScreenController(window.innerWidth);
        $caa314fd11aa2268$var$numbersOfPages($caa314fd11aa2268$var$DATA);
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(1));
    }
    if (isDeleted) {
        $caa314fd11aa2268$var$onDeletedItem(data);
        return;
    }
    if (data.length <= $caa314fd11aa2268$var$CARD_PER_PAGE) return;
    let isThreePoint = true;
    if (initialPage + $caa314fd11aa2268$var$maxVisiblePages - 1 >= $caa314fd11aa2268$var$TOTAL_PAGES) isThreePoint = false;
    $caa314fd11aa2268$var$refs.paginationContainer.innerHTML = $caa314fd11aa2268$var$createMarcupPagination(initialPage, $caa314fd11aa2268$var$maxVisiblePages, isThreePoint);
    $caa314fd11aa2268$var$createRefsPagination();
    if (isFirstRender) $caa314fd11aa2268$var$addActivePage(1);
}
function $caa314fd11aa2268$var$onClickPagination(e) {
    e.preventDefault();
    const clickOnPagePagination = e.target.closest(".js-pagination-pages");
    const clickOnButtonPagination = e.target.closest(".js-pagination-button");
    if (clickOnPagePagination) {
        const clickPage = clickOnPagePagination.dataset.pagination;
        if (clickPage === "...") console.log('case "..."');
        else $caa314fd11aa2268$var$moveToPage(clickPage);
    }
    if (clickOnButtonPagination) {
        const clickPage = clickOnButtonPagination.dataset.pagination;
        switch(clickPage){
            case "start":
                $caa314fd11aa2268$var$moveToStart();
                break;
            case "backward":
                $caa314fd11aa2268$var$moveToBackward();
                break;
            case "forward":
                $caa314fd11aa2268$var$moveToForward();
                break;
            case "end":
                $caa314fd11aa2268$var$moveToEnd();
                break;
            default:
                return;
        }
    }
}
function $caa314fd11aa2268$var$moveToStart() {
    $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, 1);
    const activePage = $caa314fd11aa2268$var$findActivePage();
    $caa314fd11aa2268$var$deleteClassActivePage(activePage);
    $caa314fd11aa2268$var$addActivePage(1);
    (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(1));
}
function $caa314fd11aa2268$var$moveToBackward() {
    const activePage = $caa314fd11aa2268$var$findActivePage();
    if (activePage === 1) return;
    const startPagePagination = Number(document.querySelector(".js-pagination-pages").dataset.pagination);
    if (activePage <= 3) {
        const initialPage = 1;
        $caa314fd11aa2268$var$deleteClassActivePage(activePage);
        $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, initialPage);
        $caa314fd11aa2268$var$addActivePage(activePage - 1);
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(activePage - 1));
    } else {
        const initialPage = startPagePagination - 1;
        $caa314fd11aa2268$var$deleteClassActivePage(activePage);
        $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, initialPage);
        $caa314fd11aa2268$var$addActivePage(activePage - 1);
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(activePage - 1));
    }
}
function $caa314fd11aa2268$var$moveToForward() {
    const activePage = $caa314fd11aa2268$var$findActivePage();
    if (activePage === $caa314fd11aa2268$var$TOTAL_PAGES) return;
    const startPgePagination = Number(document.querySelector(".js-pagination-pages").dataset.pagination);
    const initialPage = startPgePagination + 1;
    $caa314fd11aa2268$var$deleteClassActivePage(activePage);
    $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, initialPage);
    $caa314fd11aa2268$var$addActivePage(activePage + 1);
    (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(activePage + 1));
}
function $caa314fd11aa2268$var$moveToEnd() {
    $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, $caa314fd11aa2268$var$TOTAL_PAGES);
    const activePage = $caa314fd11aa2268$var$findActivePage();
    $caa314fd11aa2268$var$deleteClassActivePage(activePage);
    $caa314fd11aa2268$var$addActivePage($caa314fd11aa2268$var$TOTAL_PAGES);
    (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks($caa314fd11aa2268$var$TOTAL_PAGES));
}
function $caa314fd11aa2268$var$moveToPage(page) {
    const activePage = $caa314fd11aa2268$var$findActivePage();
    $caa314fd11aa2268$var$deleteClassActivePage(activePage);
    $caa314fd11aa2268$var$addActivePage(Number(page));
    (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(Number(page)));
}
function $caa314fd11aa2268$var$findActivePage() {
    let activePage = 1;
    $caa314fd11aa2268$var$refs.allPaginationPages.forEach((elem)=>{
        if (elem.classList.contains("js-active-pagination")) activePage = elem.dataset.pagination;
    });
    return Number(activePage);
}
function $caa314fd11aa2268$var$addActivePage(page = 1) {
    $caa314fd11aa2268$var$refs.allPaginationPages.forEach((elem)=>{
        const number = Number(elem.dataset.pagination);
        if (number === page) elem.classList.add("js-active-pagination");
    });
}
function $caa314fd11aa2268$var$deleteClassActivePage(page = 1) {
    $caa314fd11aa2268$var$refs.allPaginationPages.forEach((elem)=>{
        const number = Number(elem.dataset.pagination);
        if (number === page) elem.classList.remove("js-active-pagination");
    });
}
function $caa314fd11aa2268$var$createRefsPagination() {
    $caa314fd11aa2268$var$refs.pagination = document.querySelector(".js-pagination-list");
    $caa314fd11aa2268$var$refs.allPaginationPages = document.querySelectorAll(".js-pagination-pages");
}
function $caa314fd11aa2268$var$onDeletedItem(data) {
    $caa314fd11aa2268$var$DATA = [
        ...data
    ];
    $caa314fd11aa2268$var$numbersOfPages($caa314fd11aa2268$var$DATA);
    let activePage = 1;
    if ($caa314fd11aa2268$var$TOTAL_PAGES > 1) activePage = $caa314fd11aa2268$var$findActivePage();
    if ($caa314fd11aa2268$var$DATA.length <= $caa314fd11aa2268$var$CARD_PER_PAGE) {
        $caa314fd11aa2268$var$refs.paginationContainer.innerHTML = "";
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(1));
        return;
    }
    if (activePage > $caa314fd11aa2268$var$TOTAL_PAGES) {
        $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, $caa314fd11aa2268$var$TOTAL_PAGES);
        $caa314fd11aa2268$var$addActivePage($caa314fd11aa2268$var$TOTAL_PAGES);
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks($caa314fd11aa2268$var$TOTAL_PAGES));
        return;
    }
    if (activePage < $caa314fd11aa2268$var$TOTAL_PAGES && activePage === 1) {
        $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, 1);
        $caa314fd11aa2268$var$addActivePage(1);
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(1));
        return;
    }
    if ($caa314fd11aa2268$var$prepareDataForBooks(activePage).length <= $caa314fd11aa2268$var$CARD_PER_PAGE) {
        const startPagePagination = Number(document.querySelector(".js-pagination-pages").dataset.pagination);
        $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, startPagePagination);
        $caa314fd11aa2268$var$addActivePage(activePage);
        (0, $1a233a3e857cc48e$export$2e2bcd8739ae039)($caa314fd11aa2268$var$prepareDataForBooks(activePage));
    }
}
function $caa314fd11aa2268$var$prepareDataForBooks(page) {
    const arrayOfIndexes = [];
    const startIndex = $caa314fd11aa2268$var$CARD_PER_PAGE * (page - 1);
    for(let i = 0; i < $caa314fd11aa2268$var$CARD_PER_PAGE; i += 1)if (startIndex + i < $caa314fd11aa2268$var$DATA.length) arrayOfIndexes.push(startIndex + i);
    const newDataForRenderList = [];
    arrayOfIndexes.forEach((elem)=>newDataForRenderList.push($caa314fd11aa2268$var$DATA[elem]));
    return newDataForRenderList;
}
function $caa314fd11aa2268$var$createMarcupPagination(initialPage, maxVisiblePages, isThreePoint = true) {
    let murkupPages = "";
    if (isThreePoint) murkupPages = $caa314fd11aa2268$var$createMarcupPagesPagination(initialPage, maxVisiblePages) + `<div class="js-three-point" data-pagination="...">...</div>`;
    else murkupPages = $caa314fd11aa2268$var$createMarcupPagesPagination(initialPage, maxVisiblePages);
    return (0, $d69f682701e9dea8$export$2e2bcd8739ae039)(murkupPages);
}
function $caa314fd11aa2268$var$createMarcupPagesPagination(initialPage = 1, maxVisiblePages = 2) {
    let markupString = "";
    let newInitialPage = initialPage;
    if (initialPage + maxVisiblePages - 1 >= $caa314fd11aa2268$var$TOTAL_PAGES) newInitialPage = $caa314fd11aa2268$var$TOTAL_PAGES - maxVisiblePages + 1;
    if (maxVisiblePages > $caa314fd11aa2268$var$TOTAL_PAGES) newInitialPage = 1;
    for(let i = newInitialPage; i < initialPage + maxVisiblePages; i += 1)if (i <= $caa314fd11aa2268$var$TOTAL_PAGES) markupString += `<li class="js-pagination-pages" data-pagination="${i}">${i}</li>`;
    return markupString;
}
function $caa314fd11aa2268$var$onScreenController(width) {
    let needRender = false;
    if (width < 768 && $caa314fd11aa2268$var$screenInputControllers.a) {
        $caa314fd11aa2268$var$CARD_PER_PAGE = 4;
        $caa314fd11aa2268$var$maxVisiblePages = 2;
        $caa314fd11aa2268$var$screenInputControllers.a = false;
        $caa314fd11aa2268$var$screenInputControllers.b = true;
        needRender = true;
    }
    if (width > 768 && $caa314fd11aa2268$var$screenInputControllers.b) {
        $caa314fd11aa2268$var$CARD_PER_PAGE = 3;
        $caa314fd11aa2268$var$maxVisiblePages = 3;
        $caa314fd11aa2268$var$screenInputControllers.a = true;
        $caa314fd11aa2268$var$screenInputControllers.b = false;
        needRender = true;
    }
    return needRender;
}
window.addEventListener("resize", $caa314fd11aa2268$var$handlerScreenWidth);
function $caa314fd11aa2268$var$handlerScreenWidth() {
    const needRender = $caa314fd11aa2268$var$onScreenController(window.innerWidth);
    if (needRender) $caa314fd11aa2268$export$2e2bcd8739ae039($caa314fd11aa2268$var$DATA, 1, false, true);
}



var $4rbgP = parcelRequire("4rbgP");
const $e4901028ceec97df$var$SHOPPING_LIST_LS = "shopping list";
const $e4901028ceec97df$var$data = (0, $4rbgP.default).getData($e4901028ceec97df$var$SHOPPING_LIST_LS);
(0, $caa314fd11aa2268$export$2e2bcd8739ae039)($e4901028ceec97df$var$data, 1, true);


//# sourceMappingURL=shopping-list.1a5e5e91.js.map
